/**
 * Normalizes user search input for consistent matching and URL serialization.
 *
 * - Converts to lowercase
 * - Replaces runs of whitespace, punctuation, and special characters with a single space
 * - Trims leading/trailing whitespace
 * - Preserves Unicode letters and digits (including æ, ø, å and other accented characters)
 * - Returns undefined when no letters or digits remain
 */
export const normalizeSearchQuery = (value) => {
    if (!value) {
        return undefined;
    }
    const normalized = value
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, ' ')
        .trim();
    return normalized.length > 0 ? normalized : undefined;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9ybWFsaXplLXNlYXJjaC1xdWVyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9hcHBzL2Z1bmQtbGlzdC91dGlscy9zZWFyY2gvbm9ybWFsaXplLXNlYXJjaC1xdWVyeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7R0FRRztBQUNILE1BQU0sQ0FBQyxNQUFNLG9CQUFvQixHQUFHLENBQUMsS0FBeUIsRUFBc0IsRUFBRTtJQUNsRixJQUFJLENBQUMsS0FBSyxFQUFFLENBQUM7UUFDVCxPQUFPLFNBQVMsQ0FBQztJQUNyQixDQUFDO0lBRUQsTUFBTSxVQUFVLEdBQUcsS0FBSztTQUNuQixXQUFXLEVBQUU7U0FDYixPQUFPLENBQUMsa0JBQWtCLEVBQUUsR0FBRyxDQUFDO1NBQ2hDLElBQUksRUFBRSxDQUFDO0lBRVosT0FBTyxVQUFVLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUM7QUFDMUQsQ0FBQyxDQUFDIn0=